import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveWorkCulture,
  createWorkCulture,
  deleteWorkCulture,
  getAllActiveWorkCulture,
  getAllWorkCulture,
  getWorkCultureByID,
  WorkCultureDetailsImageUpload,
  updateWorkCulture,
} from "./services/workCulture.services";
import { IWorkCulture, IWorkCultures } from "./workCultureModal";

const initialState: IWorkCultures = {
  loading: false,
  formloading: false,
  error: "",
  WorkCultureID: null,
  WorkCultureList: [],
  WorkCultureDetail: {
    ID: null,
    ServiceID: "",
    Title: "",
    Subtitle: "",
    Description: "",
    IsActive: 1,
  },
};

const workCultureSlice = createSlice({
  name: "workculture",
  initialState,
  reducers: {
    clearWorkCultureDetails: (state) => {
      state.WorkCultureDetail = initialState.WorkCultureDetail;
    },
    setWorkCultureID: (state, action) => {
      state.WorkCultureID = action.payload;
    },
    clearWorkCultureID: (state) => {
      state.WorkCultureID = initialState.WorkCultureID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWorkCulture.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWorkCulture.fulfilled,
      (state, action: PayloadAction<IWorkCulture[]>) => {
        state.loading = false;
        state.WorkCultureList = action.payload || [];
      }
    );
    builder.addCase(getAllWorkCulture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WorkCultureList = [];
    });
    builder.addCase(createWorkCulture.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWorkCulture.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWorkCulture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWorkCulture.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWorkCulture.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWorkCulture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWorkCulture.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWorkCulture.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWorkCulture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWorkCultureByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWorkCultureByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WorkCultureDetail = action.payload;
    });
    builder.addCase(getWorkCultureByID.rejected, (state, action) => {
      state.loading = false;
      state.WorkCultureDetail = initialState.WorkCultureDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWorkCulture.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWorkCulture.fulfilled,
      (state, action: PayloadAction<IWorkCulture[]>) => {
        state.loading = false;
        state.WorkCultureList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWorkCulture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WorkCultureList = [];
    });
    builder.addCase(ActiveInactiveWorkCulture.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWorkCulture.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWorkCulture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WorkCultureDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WorkCultureDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WorkCultureDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWorkCultureDetails, clearWorkCultureID, setWorkCultureID } =
  workCultureSlice.actions;
export default workCultureSlice.reducer;
